// 云体测的所有routes here
export default [
  {
    path: '/exam/report',
    name: 'exam_report',
    component: () => import('../../views/exam/Report.vue'),
  },
  {
    path: '/exam/result-list',
    name: 'exam_result_list',
    component: () => import('../../views/exam/ResultList.vue'),
  },
  {
    path: '/exam/result-detail',
    name: 'exam_result_detail',
    component: () => import('../../views/exam/ResultDetail.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/exam/total-list',
    name: 'exam_total_list',
    component: () => import('../../views/assignment-record/List.vue'),
  },
  {
    path: '/exam/pe-result',
    name: 'exam_pe_result',
    component: () => import('../../views/exam/PEResult.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
]
